export const decorateUsername = (username: string | null | undefined, maxLength: number = 30): undefined | string => {
  if (!username) return undefined
  if (username.length < maxLength ) return `@${username}`
  return `@${username.slice(0, maxLength)}...`
}